/* global Autodesk */

import { useEffect, useRef } from "react";

export default function ForgeDwgViewer({ urn, token }) {
  const viewerDiv = useRef(null);
  let viewer = null;

  useEffect(() => {
    if (!urn || !token) return;

    const options = {
      env: "AutodeskProduction",
      accessToken: token,
    };

    Autodesk.Viewing.Initializer(options, () => {
      viewer = new Autodesk.Viewing.GuiViewer3D(viewerDiv.current);
      viewer.start();

      const documentId = `urn:${urn}`;
      Autodesk.Viewing.Document.load(
        documentId,
        (doc) => {
          const geometry = doc.getRoot().getDefaultGeometry();
          viewer.loadDocumentNode(doc, geometry);
        },
        (err) => console.error("Forge load error:", err)
      );
    });

    return () => {
      viewer?.finish();
      viewer = null;
    };
  }, [urn, token]);

  return (
    <div
      ref={viewerDiv}
      style={{ width: "100%", height: "600px", background: "#eee" }}
    ></div>
  );
}
